import { Row, Col } from "react-bootstrap";
import RadioInput from "@components/forms/RadioInput";
import { Config } from "@config/config";

const ProductType = ({ data, handleChoice, selectedChoice }) => {
  const config = new Config();

  return (
    <div className="my-5 fs-6 text-dark">
      {data.map((item) => (
        <div
          key={item.id}
          className={`my-3 rounded-4 py-2 px-3 ${
            item.id === selectedChoice ? "border-blue" : "border"
          }`}
          onClick={() => handleChoice(item)}
          style={{ cursor: "pointer" }}
        >
          <Row className="align-items-center">
            <Col sm="1" className="my-3">
              <RadioInput
                id={item.id}
                value={item.id}
                checked={item.id === selectedChoice}
                onChange={() => handleChoice(item)}
                name="SelectedChoice"
              />
            </Col>
            <Col xs="10" className="my-3">
              <div className="fs-6 text-dark">{item.name}</div>
              <div className="fw-light">{item.description}</div>
            </Col>
            <Col xs="1" className="my-3">
              <span className="text-blue">{config.icon(item.icon)}</span>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
};

export default ProductType;
